// Ingredient Cards Handler - Simple & Reliable

class IngredientCards {
  constructor() {
    this.isInitialized = false;
    this.init();
  }

  init() {
    // Wait for DOM and try multiple times
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
    
    // Also try after window load
    window.addEventListener('load', () => this.setup());
    
    // Try periodically for first 5 seconds
    let attempts = 0;
    const maxAttempts = 10;
    const interval = setInterval(() => {
      attempts++;
      
      if (this.setup() || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 500);
  }

  setup() {
    if (this.isInitialized) {
      return true;
    }

    const cards = document.querySelectorAll('.ingredient-card-mobile');

    if (cards.length === 0) {
      return false;
    }

    // Setup each card
    cards.forEach((card, index) => {
      // Remove any existing listeners
      const newCard = card.cloneNode(true);
      card.parentNode.replaceChild(newCard, card);
      
      // Add click handler
      newCard.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleCard(newCard, index);
      });
      
      // Visual debug
      newCard.style.cursor = 'pointer';
      newCard.style.transition = 'all 0.3s ease';
    });

    this.isInitialized = true;
    return true;
  }

  toggleCard(card, index) {
    // First, scroll card to center
    this.scrollCardToCenter(card);
    
    const isExpanded = card.classList.contains('expanded');
    
    // Close all other cards
    document.querySelectorAll('.ingredient-card-mobile.expanded').forEach(otherCard => {
      if (otherCard !== card) {
        otherCard.classList.remove('expanded');
      }
    });
    
    // Toggle this card
    if (isExpanded) {
      card.classList.remove('expanded');
    } else {
      card.classList.add('expanded');
    }
  }

  scrollCardToCenter(card) {
    const carousel = card.closest('.ingredients-carousel__wrapper');
    if (!carousel) {
      return;
    }

    // Use scrollIntoView with inline: 'center' for better control
    card.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }

  // Public method for manual testing
  testCard(index = 0) {
    const cards = document.querySelectorAll('.ingredient-card-mobile');
    if (cards[index]) {
      this.toggleCard(cards[index], index);
    }
  }
}

// Initialize when script loads
const ingredientCards = new IngredientCards();

// Make available globally for debugging
window.ingredientCards = ingredientCards;
window.testCard = (index) => ingredientCards.testCard(index);
